<script setup lang="ts">
import SectionHeading from '@/components/marketing/shared/SectionHeading.vue';
import StepCard from '@/components/marketing/shared/StepCard.vue';

const steps = [
    {
        title: 'Connect your website',
        description:
            'Share your URL. LaunchStation reads your products, services and brand voice, and you can correct anything it got wrong.',
    },
    {
        title: 'Tell it a goal',
        description:
            'Ask for this week of content, a product promotion, or a month of posts. Your assistant proposes a plan.',
    },
    {
        title: 'Review and approve',
        description:
            'Approve drafts, ask for changes in plain language, or allow automatic publishing on the channels you choose.',
    },
    {
        title: 'Watch it work',
        description:
            'See what was published, what is waiting for you, and how it performed, explained without the jargon.',
    },
];
</script>

<template>
    <section id="how-it-works" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="How it works"
                title="Four steps, no setup manual."
                description="No onboarding calls, no plugins to install, no marketing degree required."
            />

            <div class="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <StepCard
                    v-for="(step, index) in steps"
                    :key="step.title"
                    :step="index + 1"
                    :title="step.title"
                    :description="step.description"
                />
            </div>
        </div>
    </section>
</template>
